var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiredCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#38879F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3337 53.1673H27.667V50.334C28.2337 46.934 32.6253 45.6118 34.7503 45.3757C34.7503 45.3757 38.6591 51.7507 39.0003 51.7507C39.3415 51.7506 42.117 47.0757 43.2503 45.3757C47.217 45.3757 50.3337 48.209 50.3337 50.334V53.1673Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.667 33.334H33.3337V36.1673C33.3337 43.959 44.667 43.959 44.667 36.1673V33.334Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3337 31.9173H44.667L44.0037 25.2842C43.9781 25.0286 43.763 24.834 43.5062 24.834H34.4945C34.2376 24.834 34.0225 25.0286 33.997 25.2842L33.3337 31.9173Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6045 28.3747H40.0001M38.2918 26.7246L38.2918 29.9997",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiredCard);
export default __webpack_public_path__ + "static/media/hired-card.40743481bb6358b30b52635d62ec7b1f.svg";
export { ForwardRef as ReactComponent };